import React, { useState, useEffect } from 'react';

import { IComponentPhone } from '../../component.d';
import { RenderRequired } from './Form';
import { findCountryByCode } from '../../utils/decide_code';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

const WAIT_TIME = 60 * 1000;

const AllForFormPhone = function(props: IComponentPhone) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    placeholder,
    world,
    type
  } = props;

  const {pagedataStore, wxuserStore, uiStore} = props.rootStore!;

  const [data, setData] = useState({
    phone: '',
    code: '',
    country: '+86'
  } as any);

  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let timer = 0;
    if (errorMessage) {
      timer = window.setTimeout(() => {
        setErrorMessage('');
      }, 3000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [errorMessage]);

  const [seconds, setSeconds] = useState(0);
  const [sending, setSending] = useState(false);
  const [waiting, setWaiting] = useState(0);

  const sendSms = () => {
    const {active_on} = window.configDetail;

    if(Number(active_on)) {
      if(wxuserStore.user.is_mock) {
        return wxuserStore.auth();
      }
    }

    setSending(true);
    setWaiting(Date.now());

    pagedataStore.sendValidate(
        data.phone,
        (data.country || '').replace(/^(\+)/, '')
      )
      .then((res: any) => {
        if (res && res.data) {
          uiStore.showToast({
            content: intl.get('MessageSendSuccess')
          });
        } else {
          uiStore.showToast({
            icon: 'error-no-circle',
            content: intl.get('MessageSendError')
          });
        }
      });
  };

  useEffect(() => {
    let timer = 0;
    if (waiting) {
      setSeconds(60);
      timer = window.setInterval(() => {
        let between = WAIT_TIME - (Date.now() - waiting);
        let sec = Math.round(between / 1000);
        setSeconds(Math.max(0, sec));

        if (sec < 0) {
          clearInterval(timer);
          setWaiting(0);
          setSending(false);
        }
      });
    }

    return () => {
      clearInterval(timer);
    };
  }, [waiting]);

  const [validating, setValidating] = useState(false);
  const [validated, setValidated] = useState(0);

  useEffect(() => {
    if (data && data.code && !validating && validated != 1) {
      if (data.code.match(/^\d{4}$/)) {
        // 满足要求，那么就去验证吧
        setValidating(true);
        pagedataStore.validateCodeV2(
            data.phone,
            (data.country || '').replace(/^(\+)/, ''),
            data.code
          )
          .then((res: any) => {
            if (res && res.code == 200) {
              // 验证通过
              setValidated(1);
              onChange(type, field, data);
            } else {
              // 验证失败
              setData({
                ...data,
                code: ''
              });
              setValidated(-1);
            }

            setValidating(false);
          }).catch((err:any)=>{
            setData({
              ...data,
              code: ''
            });
            setValidated(-1);
            setValidating(false);

            if(err && err == '500') {
              if(wxuserStore.user.is_mock) {
                return wxuserStore.auth();
              }
            }
          });
      }
    }
  }, [data ? data.code : 0, validating, validated]);

  return (
    <div className="all-for-phone">
      <div
        key={errorMessage}
        className="weui-toptips weui-toptips_warn"
        style={
          errorMessage
            ? { display: 'block', opacity: 1 }
            : { display: 'none', opacity: 0 }
        }
      >
        {errorMessage}
      </div>
      <div className="weui-cells__group weui-cells__group_form">
        <div className="weui-cells weui-cells_form">
          <div className={`weui-cell weui-cell_active`}>
            {world ? (
              <div className="weui-cell__hd">
                <label
                  className="weui-label"
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <input
                    className="weui-input"
                    value={data.country}
                    onChange={e => {
                      let result = {
                        ...data,
                        country: e.target.value
                      };
                      setData(result);
                      // onChange(`phone`, field, result);
                    }}
                  />
                </label>
              </div>
            ) : (
              <div className="weui-cell__hd">
                <label className="weui-label">
                  {field} {RenderRequired(required)}
                </label>
              </div>
            )}
            <div className="weui-cell__bd">
              <input
                className="weui-input"
                placeholder={placeholder}
                value={data.phone}
                onChange={e => {
                  let result = {
                    ...data,
                    phone: e.target.value
                  };
                  setData(result);
                  // onChange(`phone`, field, result);
                }}
              />
            </div>
          </div>
          <div className="weui-cell weui-cell_active weui-cell_vcode">
            <div className="weui-cell__hd">
              <label className="weui-label">验证码</label>
            </div>
            <div className="weui-cell__bd custom-code-validate">
              <input
                className="weui-input"
                type="text"
                pattern="[0-9]*"
                placeholder="请输入验证码"
                maxLength={4}
                readOnly={validated === 1}
                value={data.code}
                onChange={e => {
                  let result = {
                    ...data,
                    code: e.target.value
                  };
                  setData(result);
                  // onChange(`phone`, field, result);
                }}
              />
              {validated < 0 ? (
                <i className="weui-icon-warn"></i>
              ) : validated > 0 ? (
                <i className="weui-icon-success"></i>
              ) : null}
            </div>
            <div className="weui-cell__ft">
              <button
                className={`weui-btn weui-vcode-btn weui-btn_default`}
                onClick={() => {
                  if (data.phone) {
                    // 这里要发短信请求
                    if (!sending && !waiting && validated != 1) {
                      sendSms();
                    }
                  } else {
                    setErrorMessage(`${intl.get('Please input the')}${field}`);
                  }
                }}
              >
                {validated == 1
                  ? '验证成功'
                  : sending && waiting
                  ? seconds + 'S'
                  : '获取验证码'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject('rootStore')(observer(AllForFormPhone));
